import { Injectable } from '@angular/core';
import { CanActivate, Router, RouterStateSnapshot, ActivatedRouteSnapshot } from '@angular/router';
import { GlobalService } from '../services/global/global.service';
import { UserModel } from '../models/user.model';
import { AzureAwsSwitchService } from './azure-aws-switch.service';

@Injectable()
export class AuthGuardService implements CanActivate {
    user: UserModel = new UserModel();

    constructor(
        private router: Router,
        private globals: GlobalService,
        private azureAws: AzureAwsSwitchService
    ) { }

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        console.log("AUTH: AuthGuard-canActivate");
        if (!this.globals.isConnected) { //{No internet connection
            console.log('AuthGuard: Not connected');
            return true;
        }

        // if ((state.url == "/?i=" || (!this.globals.isInstalled && this.globals.isiOS)) && (!this.globals.overrideInstallRequirement)) {
        //     //////////////////////////////////////////////////////////////////////////////////////
        //     //is iOS but is not installed....    
        //     //////////////////////////////////////////////////////////////////////////////////////
        //     this.router.navigate(['/installpage'], { skipLocationChange: true });
        //     return false;
        if (this.azureAws.isLogged) {            
            console.log('AuthGuard: true');
            return true; 
        } else if (localStorage.getItem("adal.error") == "access_denied") {
            this.router.navigate(['/loginerrorpage'], { skipLocationChange: true });
            return false;
        } else {
            this.user = new UserModel();
            this.globals.SetUser(this.user);
            localStorage.setItem("returnUrl", state.url);
            this.router.navigate(['/login'], { queryParams: { returnUrl: state.url } });
            return false;
        }
    }

    canActivateChild(childRoute: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean {
        console.log("AUTH: AuthGuard-canActivateChild");
        return this.canActivate(childRoute, state);
    }
}
/*
ORIGINAL
========

import { Injectable } from '@angular/core';
import { CanActivate, Router, ActivatedRouteSnapshot, RouterStateSnapshot, ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { AdalService } from 'adal-angular4';
import { GlobalService } from '../../services/global/global.service';
import { UserModel } from '../../models/user.model';
//import { LocalStorage } from '@ngx-pwa/local-storage';
import { SettingsProvider } from './settings-provider.service';

@Injectable()
export class AdalGuard implements CanActivate {
    user: UserModel = new UserModel();

    constructor(private adalService: AdalService,
        private router: Router,
        private route: ActivatedRoute,
//        protected localStorage: LocalStorage,
        public settingsProvider: SettingsProvider,
        private globals: GlobalService
    ) { }

    canActivate(
        next: ActivatedRouteSnapshot,
        state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
        console.log('AuthGuard');
        console.log(state);
        console.log(next);
        return new Promise((resolve, reject) => {

            if (!this.globals.isConnected) { //{No internet connection
                console.log('AuthGuard: Not connected');
                resolve(true);
            }
            if (this.adalService.userInfo.authenticated) {
                this.user.name = this.adalService.userInfo.profile.name;
                this.user.given_name = this.adalService.userInfo.profile.given_name;
                this.user.family_name = this.adalService.userInfo.profile.family_name;
                this.user.username = this.adalService.userInfo.userName;
                this.user.ipaddr = this.adalService.userInfo.profile.ipaddr;
                this.globals.SetUser(this.user);
                console.log('AuthGuard: true');
                
                // let url = localStorage.getItem('url');
                // if (url == '/')
                //     resolve(true);
                // if (Object.prototype.toString.call(url) == '[object String]' && state.url != url.toString() && url != '/') {
                //     //localStorage.setItem('url', '/');
                //     this.router.navigate(['/' + url]);
                //     resolve(false);
                //     return;
                // }
                resolve(true);
            } else {
                console.log('AuthGuard: Not authenticated');                
                this.user = new UserModel();
                this.globals.SetUser(this.user);
                localStorage.setItem('url', state.url);
                //this.router.navigate(['login'], { queryParams: { returnUrl: state.url }});
                this.adalService.login();
                resolve(false);
            }
        });
    }
}
*/